module.exports = __webpack_public_path__ + "static/media/DENMARK.be60e04c.svg";